const data =
{
  id: 1,
  title: 'Write the correct form of the verb',
  subTitle: 'Chia dạng đúng của động từ',
  question: 'He can (go) ___',
  // answers: 'go',
  answers: [
    { id: 1, answer: 'go', isCorrect: true },
  ],
};

export default data;
